import MenuConfigType from '@app/types/MenuConfigType';
import { SearchOutlined } from '@ant-design/icons';

const fileSearchMenuConfig: MenuConfigType = {
  path: '/file-search/',
  title: 'File Search',
  key: 'FileSearch',
  icon: SearchOutlined,
  guard: [],
  badge: 'AI',
  badgeFeatureFlag: 'internalAIAssistant',
};

export default fileSearchMenuConfig;
